import React from 'react';

/**
 * Small inline brand-mark icons for ChatGPT (OpenAI) and Gemini.
 * Used in column headers, filter banners, and any inline label
 * that needs to indicate the AI platform context.
 */

interface PlatformIconProps {
  size?: number;
  className?: string;
}

export function ChatGptIcon({ size = 14, className }: Readonly<PlatformIconProps>): React.ReactElement {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="#0D0D0D"
      aria-hidden="true"
      className={className}
    >
      <path d="M22.282 9.821a5.985 5.985 0 0 0-.516-4.91 6.046 6.046 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.18a5.985 5.985 0 0 0-3.998 2.9 6.046 6.046 0 0 0 .743 7.097 5.98 5.98 0 0 0 .51 4.911 6.051 6.051 0 0 0 6.515 2.9A5.985 5.985 0 0 0 13.26 24a6.056 6.056 0 0 0 5.772-4.206 5.99 5.99 0 0 0 3.997-2.9 6.056 6.056 0 0 0-.747-7.073zM13.26 22.43a4.476 4.476 0 0 1-2.876-1.04l.141-.081 4.779-2.758a.795.795 0 0 0 .392-.681v-6.737l2.02 1.168a.071.071 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.494 4.494zM3.6 18.304a4.47 4.47 0 0 1-.535-3.014l.142.085 4.783 2.759a.771.771 0 0 0 .78 0l5.843-3.369v2.332a.08.08 0 0 1-.033.062L9.74 19.95a4.5 4.5 0 0 1-6.14-1.646zM2.34 7.896a4.485 4.485 0 0 1 2.366-1.973V11.6a.766.766 0 0 0 .388.677l5.815 3.355-2.02 1.168a.076.076 0 0 1-.071 0L4.001 14.614A4.5 4.5 0 0 1 2.34 7.896zm16.597 3.855-5.843-3.387L15.115 7.2a.076.076 0 0 1 .071 0l4.816 2.786a4.494 4.494 0 0 1-.676 8.105V12.48a.795.795 0 0 0-.39-.73zm2.01-3.023-.141-.085-4.774-2.782a.776.776 0 0 0-.785 0L9.409 9.23V6.897a.08.08 0 0 1 .032-.062l4.808-2.782a4.496 4.496 0 0 1 6.67 4.66zm-12.64 4.135-2.02-1.164a.08.08 0 0 1-.038-.057V6.075a4.496 4.496 0 0 1 7.375-3.453l-.142.08L8.704 5.46a.795.795 0 0 0-.393.681zm1.097-2.365 2.602-1.5 2.607 1.5v2.999l-2.597 1.5-2.607-1.5z" />
    </svg>
  );
}

export function GeminiIcon({ size = 14, className }: Readonly<PlatformIconProps>): React.ReactElement {
  // Unique gradient id per render to avoid collisions across multiple instances.
  const gradId = React.useId();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 192 192"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <path
        d="M96 0C96 52.896 52.896 96 0 96c52.896 0 96 43.104 96 96 0-52.896 43.104-96 96-96-52.896 0-96-43.104-96-96Z"
        fill={`url(#${gradId})`}
      />
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="192" y2="192" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4285F4" />
          <stop offset="1" stopColor="#34A853" />
        </linearGradient>
      </defs>
    </svg>
  );
}
